import { Checkbox, Col, Descriptions, Popconfirm, Row } from 'antd';
import { ApplicantDetailsHeaderContainerApplicantUserFieldsFragment, ApplicantDetailsHeaderContainerStaffUserFieldsFragment } from '../../../generated';
import { Tags } from '../tags';

interface ApplicantDetailsHeaderProps {
  applicantDetails: ApplicantDetailsHeaderContainerApplicantUserFieldsFragment;
  onBlockUnblockAccess: (isAccessBlocked: boolean) => Promise<void>;
  onTagsChange: (newTags: string[]) => Promise<boolean>;
  isUpdating: boolean;
  staffRolePermissionData: ApplicantDetailsHeaderContainerStaffUserFieldsFragment;
}
export const ApplicantDetailsHeader: React.FC<ApplicantDetailsHeaderProps> = (props) => {
  const descriptionItems = [
    {
      label: 'Applicant',
      children: props.applicantDetails.displayName
    }
  ];

  return (
    <Row>
      <Col span={12} style={{marginLeft: '10px'}}>
      <Descriptions items={descriptionItems} />
      <br>
      </br>
      <Tags
          readonly={props.staffRolePermissionData.role?.permissions.applicantUserPermissions.canAddOrRemoveTags === false}
          tagsData={props.applicantDetails.tags ?? []}
          onTagsChange={props.onTagsChange}
        />
      </Col>
      <Row style={{}}>
        <Col span={12}>
          {props.staffRolePermissionData.role?.permissions?.applicantUserPermissions?.canBlockAccess && (
            <Row>
              <Col>
                <Popconfirm
                  title={`Are you sure to ${props.applicantDetails.accessBlocked ? 'restore' : 'restrict'} access of ${props.applicantDetails.displayName}?`}
                  onConfirm={async () => await props.onBlockUnblockAccess(!props.applicantDetails.accessBlocked)}
                >
                  <Checkbox style={{ marginBottom: '5px', marginLeft: '20px' }} checked={props.applicantDetails.accessBlocked ?? false}>
                    Restricted
                  </Checkbox>
                </Popconfirm>
              </Col>
            </Row>
          )}
        </Col>
      </Row>
    </Row>
  );
};
